/** @format */

import { Aviation } from "../../../services";
import { toast } from "react-toastify";

const AviaOrdersParsingData = async (orderId, lang = "ru", setStateFunctions) => {
  const { setLoadingGet, setOrderData, setAviaDetails, setPartnersForTender, partners } = setStateFunctions;

  setLoadingGet(true);

  try {
    const orderData = await Aviation.getAirOrdersById(orderId, lang);
    const tenderPartnersData =
      setPartnersForTender && orderData.data.assignmentMethod !== "DirectAssignment"
        ? await Aviation.getPartnersByAirOrder(orderId)
        : { data: [] };

    const order = orderData.data;
    setOrderData(order);

    setAviaDetails(orderData.status === 200 ? orderData.data : {});

    if (setPartnersForTender) {
      const invited = (tenderPartnersData?.data || [])
        .filter(Boolean)
        .map((item) => {
          const id = typeof item === "string" ? item : item.expeditorCompanyId || item.id;
          return (
            (partners || []).find((partner) => partner.expeditorCompanyId === id) || {
              id,
              expeditorCompanyId: id,
              name: item.companyName || item.name || id,
            }
          );
        })
        .filter((item) => item.expeditorCompanyId);
      setPartnersForTender(invited);
    }
  } catch (error) {
    console.error(error);
    toast.error("Произошла ошибка, попробуйте позже");
  } finally {
    setLoadingGet(false);
  }
};

export default AviaOrdersParsingData;
